export default function CRIStatementDirective() {
  return {
    template: require('./cri-statement.html'),
    scope: {
      criFunctionId: '=',
      criCategoryId: '=',
      criSubCategoryId: '=',
      criStatement: '=',
      assessmentId: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
      form: '=',
    },
    controller: 'CRIStatementController',
    controllerAs: 'criStatementVM',
    bindToController: true,
    replace: true,
  };
}
